export const GIFT_CARD_NUMBER_REGEX = /^[0-9]{16}$/;
export const GIFT_CARD_PIN_REGEX = /^[0-9]{4,}$/;
